import { c as _c } from "react/compiler-runtime";
import { X } from "lucide-react";
import { useEffect } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ImageLightbox(t0) {
  const $ = _c(14);
  const {
    src,
    alt,
    open,
    onClose
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onClose || $[1] !== open) {
    t1 = () => {
      if (!open) {
        return;
      }
      const handler = e => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handler);
      return () => document.removeEventListener("keydown", handler);
    };
    t2 = [open, onClose];
    $[0] = onClose;
    $[1] = open;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!open) {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(X, {
      className: "h-5 w-5"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClose) {
    t4 = /*#__PURE__*/_jsx("button", {
      onClick: onClose,
      className: "absolute top-4 right-4 rounded-full bg-black/50 p-2 text-white hover:bg-black/70",
      children: t3
    });
    $[5] = onClose;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = alt ?? "";
  let t6;
  if ($[7] !== src || $[8] !== t5) {
    t6 = /*#__PURE__*/_jsx("img", {
      src: src,
      alt: t5,
      className: "max-h-[90vh] max-w-[90vw] rounded-lg object-contain",
      onClick: _temp
    });
    $[7] = src;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onClose || $[11] !== t4 || $[12] !== t6) {
    t7 = /*#__PURE__*/_jsxs("div", {
      className: "fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4",
      onClick: onClose,
      children: [t4, t6]
    });
    $[10] = onClose;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(e_0) {
  return e_0.stopPropagation();
}